/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */
export function getBrandTitles(obj) {
  // Check if object has required properties
  if (!obj[":itemsOrder"] || !obj[":items"]) return obj["items"]
  // Get an array of titles
  const titles = obj[":itemsOrder"].map(key => {
    const item = obj[":items"][key]
    return item["brand_switcher"] || ""
  })
  return titles
}
/**
 * Generates an array of brand objects from the given input object.
 *
 * @param {Object} obj - The input object containing brand information.
 * @return {Array} An array of brand objects with text, href, target, and isActive properties.
 */
export function getBrandsArray(obj) {
  const brandSwitcherArray = getBrandTitles(obj) || []
  const brandArray = brandSwitcherArray
    .map(item => {
      if (!item) return { text: "", href: "", target: "_self", isActive: false }
      return {
        text: item?.brandName || "",
        href: item?.link || "",
        target: item?.linkToNewTab === "true" ? "_blank" : "_self",
        isActive: item?.highlight || false,
        trackingAttributes: {
          "data-datalayer-id": "kds-element-navigation",
          "data-datalayer-data": JSON.stringify({
            clickInternalLinks:
              typeof window !== "undefined" &&
              item?.link?.includes(
                window.location.hostname.split(".").slice(1).join(".")
              ),
            eventAction: "brand sync",
            eventName: "brand sync",
            eventType: "click",
            internalLinkName: `brand sync:${item?.brandName?.toLowerCase()}`,
            internalLinkPosition: "global header",
            internalLinkType: "global header:navigation",
            internalLinkURL: item?.link,
            internalLinkZoneName:
              typeof window !== "undefined"
                ? `${window?.eventPageType}:global header`
                : "global header",
          }),
        },
      }
    })
    .filter(item => item.text || item.href) // Filter out empty items
  return brandArray
}
